import { AuthCallbackPage } from "@certn/auth";
import * as Sentry from "@sentry/react";
import { Route, Routes, useNavigate } from "react-router-dom";

import { ProtectedRoutes } from "./ProtectedRoutes";
import { StripePaymentContextProvider } from "../components/stripe/StripePaymentContext";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { InvoiceDetailPage } from "../pages/invoices/InvoiceDetailPage";
import { LoginPage } from "../pages/login/LoginPage";
import { SsoSplashPage } from "../pages/login/components/SsoSplashPage";

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export function BaseRoutes() {
  const navigate = useNavigate();
  useDocumentTitle();
  return (
    <SentryRoutes>
      <Route
        path="/callback"
        element={<AuthCallbackPage onContinue={() => navigate("/")} />}
      />
      <Route
        path="/pay-invoice/:invoiceId"
        element={
          <StripePaymentContextProvider>
            <InvoiceDetailPage />
          </StripePaymentContextProvider>
        }
      />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/sso" element={<SsoSplashPage />} />
      <Route path="*" element={<ProtectedRoutes />} />
    </SentryRoutes>
  );
}
